import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/schedule/quickfill-history')({
  staticData: { team: 'schedule' },
});
